/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {CostCenterResourceItemVO} from "./cost-center-resource-item-vo.model";

export class CostCenterDTO extends JSONable{

  uuid: string | null = null;

  owner: string | null = null;

  parent: CostCenterResourceItemVO | null = null;

  label: string | null = null;

  isCustomerBehalf: boolean | null = null;

  isPrivate: boolean | null = null;

}
